var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"masking-container"},[_c('div',{staticClass:"top"},[_c('HeadTitle')],1),_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-left"},[_c('LeftCharts')],1),_c('div',{staticClass:"content-middle"},[_c('MiddleStatistics')],1),_c('div',{staticClass:"content-right"},[_c('RightCharts')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }